import { Button, SuccessDialog } from '@buffer-mono/popcorn'
import { useModalManager } from '../../../ModalManager/hooks/useModalManager'
import useDismissBanner, {
  BannerTypes,
} from '../../../../common/hooks/useDismissBanner'
import { useCrossAppNavigate } from '../../../../common/hooks/useCrossAppNavigate'
import { getPublishUrl } from '@buffer-mono/shared-utils/urls'

import type { JSX } from 'react'

const ChannelGroupsPrompt = (): JSX.Element => {
  const { dismissModal } = useModalManager()
  const { onDismissBanner } = useDismissBanner({
    banner: BannerTypes.channelGroupsAnnouncement,
  })

  const navigate = useCrossAppNavigate()
  const channelGroupsUrl = getPublishUrl('settings/channel-groups')

  const handleClose = (): void => {
    onDismissBanner()
    dismissModal()
  }

  const handleCreateGroup = (): void => {
    navigate(channelGroupsUrl)
    handleClose()
  }

  return (
    <SuccessDialog open={true} onOpenChange={handleClose}>
      <SuccessDialog.Content size="medium">
        <SuccessDialog.Image
          src="https://buffer-ui.s3.amazonaws.com/illustrations/image-announcement@2x.png"
          alt="Try out the new Channel Groups feature image"
          width={432}
          height={278}
        />

        <SuccessDialog.Title>
          Organize Your Channels Into Groups
        </SuccessDialog.Title>
        <SuccessDialog.Description>
          Group your channels together for quick and easy cross-publishing.
          Perfect for managing multiple brands or clients!
        </SuccessDialog.Description>
        <SuccessDialog.Actions>
          <Button size="large" variant="primary" onClick={handleCreateGroup}>
            Create a Channel Group
          </Button>
          <Button size="large" variant="tertiary" onClick={handleClose}>
            Got It
          </Button>
        </SuccessDialog.Actions>
      </SuccessDialog.Content>
    </SuccessDialog>
  )
}

export default ChannelGroupsPrompt
